import {getInductPackageMetrics} from "../resources/InductResource";
import {getStowCarts, getStowFloors, getStowPackageMetrics} from "../resources/StowResource";
import {getDateInMMDDYYYYWithOffset} from "../Utility";
import {getPickPackageMetrics} from "../resources/PickResource";
import {CartData, FloorData, InductPackageMetric, Resource, StowPackageMetric} from "../enums";

export const LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR = "LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR";
export const LOAD_METRICS_FOR_FLOOR_CALL_BEGIN = "LOAD_METRICS_FOR_FLOOR_CALL_BEGIN";
export const LOAD_METRICS_FOR_FLOOR_CALL_FAILURE = "LOAD_METRICS_FOR_FLOOR_CALL_FAILURE";
export const LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR = "LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR";
export const LOAD_STOW_CART_DATA_FOR_FLOOR = "LOAD_STOW_CART_DATA_FOR_FLOOR";
export const LOAD_STOW_FLOOR_DATA_FOR_FLOOR = "LOAD_STOW_FLOOR_DATA_FOR_FLOOR";
export const LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR = "LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR";

const loadInductPackageMetricsForFloor = (inductPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR,
    inductPackageMetricsMap
});

const loadMetricsForFloorCallBegin = () => ({
    type: LOAD_METRICS_FOR_FLOOR_CALL_BEGIN
});

const loadMetricsForFloorCallFailure = () => ({
    type: LOAD_METRICS_FOR_FLOOR_CALL_FAILURE
});

const loadPickPackageMetricsForFloor = (pickPackageMetricsMap) => ({
    type: LOAD_PICK_PACKAGE_METRICS_FOR_FLOOR,
    pickPackageMetricsMap
});

const loadStowCartDataForFloor = (stowCartData) => ({
    type: LOAD_STOW_CART_DATA_FOR_FLOOR,
    stowCartData
})

const loadStowFloorDataForFloor = (stowFloorsData) => ({
    type: LOAD_STOW_FLOOR_DATA_FOR_FLOOR,
    stowFloorsData
});

const loadStowPackageMetricsForFloor = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR,
    stowPackageMetricsMap
});

export const getInductPackageMetricsForFloor = (nodeId, stationPairs) => {
    return async (dispatch) => {
        dispatch(loadMetricsForFloorCallBegin());
        try {
            const request = constructInductPackageMetricsRequest(nodeId, stationPairs);
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            if (inductPackageMetricsMap) {
                dispatch(loadInductPackageMetricsForFloor(inductPackageMetricsMap));
            } else {
                dispatch(loadMetricsForFloorCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForFloorCallFailure());
        }
    }
}

export const getPickPackageMetricsForFloor = (nodeId, stationPairs) => {
    return async (dispatch) => {
        dispatch(loadMetricsForFloorCallBegin());
        try {
            const request = constructPickPackageMetricsRequest(nodeId, stationPairs);
            const pickPackageMetricsMap = await getPickPackageMetrics(request);
            if (pickPackageMetricsMap) {
                dispatch(loadPickPackageMetricsForFloor(pickPackageMetricsMap));
            } else {
                dispatch(loadMetricsForFloorCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForFloorCallFailure());
        }
    }
}

export const getStowCartDataForFloor = (nodeId, floor) => {
    return async (dispatch) => {
        dispatch(loadMetricsForFloorCallBegin());
        try {
            const request = constructStowCartDataRequest(nodeId, floor);
            const stowCartData = await getStowCarts(request);
            if (stowCartData) {
                dispatch(loadStowCartDataForFloor({floor: floor, cartData: stowCartData[0]}));
            } else {
                dispatch(loadMetricsForFloorCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForFloorCallFailure());
        }
    }
}

export const getStowFloorDataForFloor = (nodeId, stationPairs) => {
    return async (dispatch) => {
        dispatch(loadMetricsForFloorCallBegin());
        try {
            const request = constructStowFloorDataRequest(nodeId, stationPairs);
            const stowFloorsDataMap = await getStowFloors(request);
            if (stowFloorsDataMap) {
                dispatch(loadStowFloorDataForFloor(stowFloorsDataMap));
            } else {
                dispatch(loadMetricsForFloorCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForFloorCallFailure());
        }
    }
}

export const getStowPackageMetricsForFloor = (nodeId, stationPairs) => {

    return async (dispatch) => {
        dispatch(loadMetricsForFloorCallBegin());
        try {
            const request = constructStowPackageMetricsRequest(nodeId, stationPairs);
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                delete stowPackageMetricsMap['Total']
                dispatch(loadStowPackageMetricsForFloor(stowPackageMetricsMap));
            } else {
                dispatch(loadMetricsForFloorCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForFloorCallFailure());
        }
    }
}

const constructInductPackageMetricsRequest = (nodeId, stationPairs) => {
    return {
        groupBy: "Floor",
        nodeId: nodeId,
        metricList: [InductPackageMetric.INDUCTED],
        filters: {
            StationPair: stationPairs
        }
    }
}

const constructPickPackageMetricsRequest = (nodeId, stationPairs) => {
    return {
        groupBy: Resource.FLOOR_LOCATION,
        stationCode: nodeId,
        metricList: ["PICKED"],
        date: getDateInMMDDYYYYWithOffset(0),
        filters: {
            stationPair: stationPairs
        }
    }
}

const constructStowCartDataRequest = (nodeId, floor) => {
    return {
        filters: {
            NODE: [nodeId],
            FLOOR: [floor]
        },
        fieldsRequired: [
            CartData.CART_LABEL,
            CartData.BIN_DATA
        ]
    }
}

const constructStowFloorDataRequest = (nodeId, stationPairs) => {
    return {
        filters: {
            NODE: [nodeId],
            STATION_PAIR: stationPairs
        },
        fieldsRequired: [
            FloorData.FLOOR_LABEL,
            FloorData.ROUTE_CODE,
            FloorData.CART_DATA
        ]
    }
}

const constructStowPackageMetricsRequest = (nodeId, stationPairs) => {
    return {
        groupBy: Resource.FLOOR,
        filters: {
            NODE: [nodeId],
            STATION_PAIR: stationPairs
        },
        metrics: [
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.PROBLEM_SOLVE_COUNT
        ]
    }
}



// WEBPACK FOOTER //
// ./src/actions/FloorActions.js